module.exports = "<div class=\"box-white pt-2 pb-2 detail-product\">\r\n    <div class=\"container-main\">\r\n        <div class=\"container-fluid\">\r\n            <div class=\"pt-2\">\r\n                <div id=\"detail\" class=\"col-12 col-md-12 col-sm-12\" [innerHTML]=\"item.detail | sanitizeHtml\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/frontend/pages/pages.component.html
// module id = ./src/app/frontend/pages/pages.component.html
// module chunks = frontend.module